var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90059 1.06443C2.90059 1.62701 2.44452 2.08308 1.88194 2.08308C1.31935 2.08308 0.863289 1.62701 0.863289 1.06443C0.863289 0.501842 1.31935 0.0457764 1.88194 0.0457764C2.44452 0.0457764 2.90059 0.501842 2.90059 1.06443Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46587 1.06445C6.46587 1.62703 6.0098 2.0831 5.44722 2.0831C4.88463 2.0831 4.42857 1.62703 4.42857 1.06445C4.42857 0.501861 4.88463 0.0457951 5.44722 0.0457951C6.0098 0.0457951 6.46587 0.501861 6.46587 1.06445Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90058 5.13906C2.90058 5.70164 2.44452 6.15771 1.88193 6.15771C1.31935 6.15771 0.863281 5.70164 0.863281 5.13906C0.863281 4.57647 1.31935 4.12041 1.88193 4.12041C2.44452 4.12041 2.90058 4.57647 2.90058 5.13906Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46587 5.13906C6.46587 5.70164 6.0098 6.15771 5.44722 6.15771C4.88463 6.15771 4.42857 5.70164 4.42857 5.13906C4.42857 4.57647 4.88463 4.12041 5.44722 4.12041C6.0098 4.12041 6.46587 4.57647 6.46587 5.13906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90058 9.21362C2.90058 9.77621 2.44452 10.2323 1.88193 10.2323C1.31935 10.2323 0.863281 9.77621 0.863281 9.21362C0.863281 8.65104 1.31935 8.19497 1.88193 8.19497C2.44452 8.19497 2.90058 8.65104 2.90058 9.21362Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46587 9.21362C6.46587 9.77621 6.0098 10.2323 5.44722 10.2323C4.88463 10.2323 4.42857 9.77621 4.42857 9.21362C4.42857 8.65104 4.88463 8.19497 5.44722 8.19497C6.0098 8.19497 6.46587 8.65104 6.46587 9.21362Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/Prescription.ec97d0f8cb371c4fe3dacb257e93765e.svg";
export { ForwardRef as ReactComponent };